export const FETCH_FLEETBACK_MEDIAS_CLIPPING_REQUEST = 'SALES/CLIPPING/FLEETBACK_MEDIAS/FETCH_REQUEST';
export const FETCH_FLEETBACK_MEDIAS_CLIPPING_SUCCESS = 'SALES/CLIPPING/FLEETBACK_MEDIAS/FETCH_SUCCESS';
export const FETCH_FLEETBACK_MEDIAS_CLIPPING_FAILURE = 'SALES/CLIPPING/FLEETBACK_MEDIAS/FETCH_FAILURE';
